import { render } from "./public_and_external_timeline.vue?vue&type=template&id=f6923484"
import script from "./public_and_external_timeline.js?vue&type=script&lang=js"
export * from "./public_and_external_timeline.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__